import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot } from '@angular/router';

import { ProjectFilterService } from '@core/services/project-filter.service';

export const projectFilterGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const projectFilterService = inject(ProjectFilterService);

  // Получаем projectId из параметров маршрута или используем 'all' для корневого маршрута
  let projectId = route.parent?.parent?.params['projectId'];

  // Если это корневой маршрут (path: ''), используем 'all'
  if (!projectId && route.routeConfig?.path === '') {
    projectId = 'all';
  }

  if (!projectId) {
    return true;
  }

  // Проверяем, есть ли параметр autoFilter
  const hasAutoFilter = route.queryParams['autoFilter'];

  if (hasAutoFilter) {
    return true;
  }

  // Проверяем, есть ли параметр id (переход к конкретной задаче)
  const hasTaskId = route.queryParams['id'];

  if (hasTaskId) {
    // Если есть id задачи, не применяем сохраненный фильтр
    return true;
  }

  // Проверяем, есть ли другие query параметры
  const queryParams = { ...route.queryParams };
  delete queryParams['autoFilter'];
  const hasOtherQueryParams = Object.keys(queryParams).length > 0;

  if (hasOtherQueryParams) {
    return true;
  }

  // Получаем сохраненный фильтр для проекта
  const savedFilter = projectFilterService.getLastProjectFilter(projectId);

  console.log('savedFilter', savedFilter);

  if (!savedFilter || Object.keys(savedFilter).length === 0) {
    return true;
  }

  // Создаем новые query параметры с добавлением autoFilter
  const newQueryParams = {
    ...savedFilter,
    autoFilter: 'true',
  };

  // Для корневого маршрута редиректим на cabinet/all/load/list
  if (route.routeConfig?.path === '') {
    return router.createUrlTree(['/cabinet/all/load/list'], {
      queryParams: newQueryParams,
    });
  }

  // Для остальных маршрутов - стандартная логика
  const segments = [];
  let currentRoute = route;

  // Собираем все сегменты пути
  while (currentRoute) {
    if (currentRoute.url.length > 0) {
      segments.unshift(...currentRoute.url.map(segment => segment.path));
    }
    currentRoute = currentRoute.parent;
  }

  const fullPath = '/' + segments.join('/');

  console.log('fullPath', fullPath);

  // Выполняем редирект с сохраненными параметрами фильтра и флагом autoFilter
  return router.createUrlTree([fullPath], {
    queryParams: newQueryParams,
  });
};
